import { Moon, Sun } from "lucide-react";
import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import BookCTA from "@/components/BookCTA";
import logo from "@/assets/logo.png";

const navLinks = [
  { label: "Home", href: "/" },
  { label: "Tools", href: "/tools" },
  { label: "Blog", href: "/blog" },
  { label: "Co-Found", href: "/co-found" },
  { label: "About", href: "/about" },
];

const getInitialTheme = (): "dark" | "light" => {
  if (typeof window === "undefined") return "light";
  const stored = localStorage.getItem("theme");
  if (stored === "dark" || stored === "light") return stored;
  return window.matchMedia("(prefers-color-scheme: dark)").matches ? "dark" : "light";
};

const Navbar = () => {
  const [isDark, setIsDark] = useState<boolean>(() => getInitialTheme() === "dark");
  const location = useLocation();

  useEffect(() => {
    const theme = isDark ? "dark" : "light";
    document.documentElement.classList.toggle("dark", isDark);
    localStorage.setItem("theme", theme);
  }, [isDark]);

  return (
    <nav className="brutal-border border-t-0 border-l-0 border-r-0 bg-background sticky top-0 z-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 font-black text-lg tracking-tight text-foreground">
          <img src={logo} alt="Co-Found with Us logo" className="w-10 h-10 rounded-md" />
          <span className="font-black tracking-tight">Co-Found with Us</span>
        </Link>

        <div className="hidden md:flex items-center gap-1">
          {navLinks.map((link) => (
            <Link
              key={link.href}
              to={link.href}
              className={`font-bold text-sm tracking-wide px-4 py-2 rounded-md transition-colors uppercase tracking-[0.08em] ${
                location.pathname === link.href
                  ? "text-primary"
                  : "text-foreground hover:text-primary"
              }`}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <BookCTA className="hidden sm:inline-flex" size="md" source="navbar">Get Early Access →</BookCTA>

          <button
            onClick={() => setIsDark(!isDark)}
            className="brutal-border brutal-shadow w-10 h-10 flex items-center justify-center bg-card hover:bg-muted transition-colors rounded-md"
            aria-label="Toggle dark mode"
          >
            {isDark ? <Sun className="w-4 h-4" /> : <Moon className="w-4 h-4" />}
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
